import React from 'react';
import { ScarcityBanner } from '../components/ScarcityBanner';
import { HeroLP4 } from '../components/HeroLP4';
import { Testimonial } from '../components/Testimonial';
import { WebsiteDemoLP4 } from '../components/WebsiteDemoLP4';
import { ProblemSolutionLP4 } from '../components/ProblemSolutionLP4';
import { ValueStackLP4 } from '../components/ValueStackLP4';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { ClosingLP4 } from '../components/ClosingLP4';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP4() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1415">
      <ScarcityBanner data-id="element-1416" />
      <HeroLP4 data-id="element-1417" />
      <Testimonial data-id="element-1418" />
      <WebsiteDemoLP4 data-id="element-1419" />
      <ProblemSolutionLP4 data-id="element-1420" />
      <ValueStackLP4 data-id="element-1421" />
      <ModuleBreakdown data-id="element-1422" />
      <Guarantee data-id="element-1423" />
      <ClosingLP4 data-id="element-1424" />
      <Footer data-id="element-1425" />
      <RecentPurchaseToast data-id="element-1426" />
    </div>;
}